{
  "name": "entscheidungsnavi",
  "version": "8.3.2",
  "license": "ISC",
  "private": true,
  "engines": {
    "node": ">=20.11.1",
    "npm": ">=10.2.4"
  },
  "web-types": "./web-types.json",
  "scripts": {
    "i18n": "nx extract-i18n",
    "ng": "nx",
    "postinstall": "pnpm run supported-browsers",
    "nx": "nx",
    "start": "nx serve",
    "start:en": "pnpm run start -- --configuration en",
    "supported-browsers": "node tools/supported-browsers.mjs",
    "test": "nx run-many --all --target=test --parallel",
    "lint": "nx run-many --all --target=lint",
    "e2e": "nx run-many --all --target=e2e",
    "affected:apps": "nx affected:apps",
    "affected:libs": "nx affected:libs",
    "affected:build": "nx affected:build",
    "affected:e2e": "nx affected:e2e",
    "affected:test": "nx affected:test",
    "affected:lint": "nx affected:lint",
    "affected:dep-graph": "nx affected:dep-graph",
    "affected": "nx affected",
    "format": "nx format:write",
    "format:write": "nx format:write",
    "format:check": "nx format:check",
    "update": "nx migrate latest",
    "dep-graph": "nx dep-graph",
    "help": "nx help",
    "workspace-generator": "nx workspace-generator",
    "prepare": "husky install",
    "sentry:sourcemaps:frontend": "sentry-cli sourcemaps inject --org efi --project frontend ./dist/apps/decision-tool/browser && sentry-cli --url https://sentry.entscheidungsnavi.de sourcemaps upload --org efi --project frontend ./dist/apps/decision-tool/browser",
    "sentry:sourcemaps:cockpit": "sentry-cli sourcemaps inject --org efi --project cockpit ./dist/apps/cockpit/browser && sentry-cli --url https://sentry.entscheidungsnavi.de sourcemaps upload --org efi --project frontend ./dist/apps/cockpit/browser",
    "sentry:sourcemaps:klug": "sentry-cli sourcemaps inject --org efi --project klugnavi ./dist/apps/decision-tool/browser && sentry-cli --url https://sentry.entscheidungsnavi.de sourcemaps upload --org efi --project klugnavi ./dist/apps/decision-tool/browser"
  },
  "dependencies": {
    "@angular/animations": "19.1.8",
    "@angular/cdk": "19.1.5",
    "@angular/common": "19.1.8",
    "@angular/compiler": "19.1.8",
    "@angular/core": "19.1.8",
    "@angular/forms": "19.1.8",
    "@angular/localize": "19.1.8",
    "@angular/material": "19.1.5",
    "@angular/platform-browser": "19.1.8",
    "@angular/platform-browser-dynamic": "19.1.8",
    "@angular/router": "19.1.8",
    "@angular/service-worker": "19.1.8",
    "@fontsource/roboto": "^5.0.8",
    "@nestjs/axios": "^3.0.2",
    "@nestjs/common": "10.2.10",
    "@nestjs/config": "3.1.1",
    "@nestjs/core": "10.2.10",
    "@nestjs/mapped-types": "2.0.4",
    "@nestjs/mongoose": "10.0.2",
    "@nestjs/passport": "10.0.3",
    "@nestjs/platform-express": "10.2.10",
    "@nestjs/throttler": "5.1.1",
    "@schematics/angular": "19.1.9",
    "@sentry/angular": "^8.42.0",
    "@sentry/cli": "^2.39.0",
    "@sentry/nestjs": "^8.44.0",
    "@swimlane/ngx-charts": "^22.0.0-alpha.0",
    "angulartics2": "^12.2.1",
    "body-parser": "^1.20.2",
    "class-transformer": "^0.5.1",
    "class-validator": "^0.14.1",
    "connect-mongo": "^5.1.0",
    "core-js": "^3.36.0",
    "csrf-sync": "^4.0.3",
    "d3-interpolate-path": "^2.3.0",
    "diff-match-patch": "^1.0.5",
    "escape-string-regexp": "^5.0.0",
    "exceljs": "^4.4.0",
    "express-session": "^1.18.0",
    "file-saver": "^2.0.5",
    "helmet": "^7.1.0",
    "html-to-image": "^1.11.11",
    "joi": "^17.12.2",
    "jszip": "^3.10.1",
    "katex": "^0.16.9",
    "lodash": "^4.17.21",
    "material-symbols": "^0.16.0",
    "mathjs": "^12.4.0",
    "mongoose": "^8.12.0",
    "ngx-color": "^9.0.0",
    "ngx-quill": "^24.0.5",
    "nodemailer": "^6.9.10",
    "passport": "^0.7.0",
    "passport-local": "^1.0.0",
    "passport-local-mongoose": "^8.0.0",
    "pdfmake": "^0.2.9",
    "quill": "^1.3.7",
    "quill-blot-formatter": "~1.0.5",
    "quill-delta": "^5.1.0",
    "reflect-metadata": "^0.1.14",
    "ress": "^5.0.2",
    "rxjs": "~7.8.1",
    "sanitize-filename": "^1.6.3",
    "semver": "^7.6.0",
    "tslib": "^2.6.2",
    "uuid": "^9.0.1",
    "zone.js": "0.15.0",
    "zxcvbn": "^4.4.2"
  },
  "devDependencies": {
    "@angular-devkit/build-angular": "19.1.9",
    "@angular-devkit/core": "19.1.9",
    "@angular-devkit/schematics": "19.1.9",
    "@angular-eslint/eslint-plugin": "19.2.0",
    "@angular-eslint/eslint-plugin-template": "19.2.0",
    "@angular-eslint/template-parser": "19.2.0",
    "@angular/cli": "~19.1.0",
    "@angular/compiler-cli": "19.1.8",
    "@angular/language-service": "19.1.8",
    "@nestjs/schematics": "10.0.3",
    "@nestjs/testing": "10.2.10",
    "@nx-tools/container-metadata": "^6.1.1",
    "@nx-tools/nx-container": "^6.8.0",
    "@nx/angular": "20.4.6",
    "@nx/devkit": "20.4.6",
    "@nx/esbuild": "20.4.6",
    "@nx/eslint": "20.4.6",
    "@nx/eslint-plugin": "20.4.6",
    "@nx/jest": "20.4.6",
    "@nx/js": "20.4.6",
    "@nx/nest": "20.4.6",
    "@nx/node": "20.4.6",
    "@nx/playwright": "20.4.6",
    "@nx/workspace": "20.4.6",
    "@percy/cli": "^1.28.0",
    "@percy/playwright": "^1.0.8",
    "@playwright/test": "^1.36.0",
    "@types/d3-interpolate-path": "^2.0.3",
    "@types/d3-scale": "^4.0.8",
    "@types/d3-selection": "^3.0.10",
    "@types/d3-shape": "^3.1.6",
    "@types/d3-transition": "^3.0.8",
    "@types/diff-match-patch": "^1.0.36",
    "@types/express": "4.17.21",
    "@types/express-session": "^1.17.10",
    "@types/file-saver": "^2.0.7",
    "@types/jest": "29.5.14",
    "@types/katex": "^0.16.7",
    "@types/lodash": "^4.14.202",
    "@types/node": "20.11.1",
    "@types/nodemailer": "^6.4.14",
    "@types/passport-local": "^1.0.38",
    "@types/passport-local-mongoose": "^6.1.5",
    "@types/pdfmake": "^0.2.9",
    "@types/quill": "^2.0.14",
    "@types/resize-observer-browser": "^0.1.11",
    "@types/semver": "^7.5.8",
    "@types/supertest": "^2.0.16",
    "@types/uuid": "^9.0.8",
    "@types/zxcvbn": "^4.4.4",
    "@typescript-eslint/eslint-plugin": "7.18.0",
    "@typescript-eslint/parser": "7.18.0",
    "@typescript-eslint/utils": "^7.16.0",
    "browserslist-useragent-regexp": "^4.1.1",
    "dotenv": "16.3.1",
    "eslint": "8.57.0",
    "eslint-config-prettier": "9.1.0",
    "eslint-plugin-deprecation": "^2.0.0",
    "eslint-plugin-import": "^2.29.1",
    "eslint-plugin-playwright": "^1.6.2",
    "eslint-plugin-tsdoc": "^0.2.17",
    "express-http-proxy": "^2.1.1",
    "husky": "^8.0.3",
    "jest": "29.7.0",
    "jest-environment-jsdom": "29.7.0",
    "jest-preset-angular": "14.4.2",
    "lint-staged": "^15.2.2",
    "mongodb-memory-server": "^10.1.2",
    "nx": "20.4.6",
    "prettier": "3.3.3",
    "start-server-and-test": "2.0.8",
    "supertest": "^6.3.4",
    "ts-jest": "29.1.1",
    "ts-node": "10.9.2",
    "typescript": "5.7.3"
  },
  "overrides": {
    "ngx-quill": {
      "@angular/core": "19.1.8"
    }
  },
  "packageManager": "pnpm@10.11.0+sha512.6540583f41cc5f628eb3d9773ecee802f4f9ef9923cc45b69890fb47991d4b092964694ec3a4f738a420c918a333062c8b925d312f42e4f0c263eb603551f977"
}
